// LIBRARIES
import styled from "styled-components";
import EditIcon from "@mui/icons-material/Edit";

// MISC
import { COLORS, BOXSHADOW, FONTS } from "constants/styleVariables";

export const ContainerItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  background: #F5F5F5;
  min-width: 350px;
  min-height: 200px;
  margin: 0 60px 60px 0;
  // box-shadow: ${BOXSHADOW.containerBoxShadow};
  border-radius: 24px;
  cursor: pointer;
  z-index: 2;
`;
export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TitleIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
export const Containers = styled.div`
  z-index: 20;
`;
export const EditIconContainer = styled(EditIcon)``;
export const TitleContainer = styled.text`
  font-size: 22px;
  font-weight: bold;
  font-family: ${FONTS.newsharp};
  color: ${COLORS.rainbowIndigo};
`;
export const StatusContainer = styled.text`
  font-size: 16px;
  font-weight: 600;
  font-family: ${FONTS.montserrat};
  color: ${COLORS.secondaryGray};
`;
export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const TextDetailsContainer = styled.text`
  font-size: 18px;
  font-weight: bold;
  color: ${COLORS.secondaryBlack};
  margin-bottom: 15px;
  font-family: ${FONTS.newsharp};
`;
export const ImageContainer = styled.div`
  position: absolute;
  right: 20px;
  bottom: 20px;
`;
export const ImageContent = styled.img`
  max-width: 98px;
  max-height: 59px;
`;
